// All countries
// length 252
export const countriesArr = [
  "Кыргызстан",
  "Афганистан",
  "Аландские острова",
  "Албания",
  "Алжир",
  "Американское Самоа",
  "Андорра",
  "Ангола",
  "Ангилья",
  "Антарктида",
  "Антигуа и Барбуда",
  "Аргентина",
  "Армения",
  "Аруба",
  "Австралия",
  "Австрия",
  "Азербайджан",
  "Багамы",
  "Бахрейн",
  "Бангладеш",
  "Барбадос",
  "Беларусь",
  "Бельгия",
  "Белиз",
  "Бенин",
  "Бермуды",
  "Бутан",
  "Боливия",
  "Бонэйр, Синт-Эстатиус и Саба",
  "Босния и Герцеговина",
  "Ботсвана",
  "Остров Буве",
  "Бразилия",
  "Британская территория Индийского океана",
  "Бруней-Даруссалам",
  "Болгария",
  "Буркина-Фасо",
  "Бурунди",
  "Камбоджа",
  "Камерун",
  "Канада",
  "Кабо-Верде",
  "Каймановы острова",
  "Центрально-Африканская Республика",
  "Чад",
  "Чили",
  "Китай",
  "Остров Рождества",
  "Кокосовые (Килинг) острова",
  "Колумбия",
  "Коморские острова",
  "Конго",
  "Конго, Демократическая Республика Конго",
  "Острова Кука",
  "Коста-Рика",
  "Берег Слоновой Кости",
  "Хорватия",
  "Куба",
  "Кюрасао",
  "Кипр",
  "Чехия",
  "Дания",
  "Джибути",
  "Доминика",
  "Доминиканская Республика",
  "Эквадор",
  "Египет",
  "Эль Сальвадор",
  "Экваториальная Гвинея",
  "Эритрея",
  "Эстония",
  "Эфиопия",
  "Фолклендские (Мальвинские) острова",
  "Фарерские острова",
  "Фиджи",
  "Финляндия",
  "Франция",
  "Французская Гвиана",
  "Французская Полинезия",
  "Южные Французские Территории",
  "Габон",
  "Гамбия",
  "Грузия",
  "Германия",
  "Гана",
  "Гибралтар",
  "Греция",
  "Гренландия",
  "Гренада",
  "Гваделупа",
  "Гуам",
  "Гватемала",
  "Гернси",
  "Гвинея",
  "Гвинея-Бисау",
  "Гайана",
  "Гаити",
  "Остров Херд и острова Макдональд",
  "Святой Престол (государство-город Ватикан)",
  "Гондурас",
  "Гонконг, Китай",
  "Венгрия",
  "Исландия",
  "Индия",
  "Индонезия",
  "Иран, Исламская Республика",
  "Ирак",
  "Ирландия",
  "Остров Мэн",
  "Израиль",
  "Италия",
  "Ямайка",
  "Япония",
  "Джерси",
  "Иордания",
  "Казахстан",
  "Кения",
  "Кирибати",
  "Корея, Народно-Демократическая Республика",
  "Корея, Республика",
  "Косово",
  "Кувейт",
  "Лаосская Народно-Демократическая Республика",
  "Латвия",
  "Ливан",
  "Лесото",
  "Либерия",
  "Ливийская арабская джамахирия",
  "Лихтенштейн",
  "Литва",
  "Люксембург",
  "Макао, Китай",
  "Македония, бывшая югославская Республика",
  "Мадагаскар",
  "Малави",
  "Малайзия",
  "Мальдивы",
  "Мали",
  "Мальта",
  "Маршалловы острова",
  "Мартиника",
  "Мавритания",
  "Маврикий",
  "Майотта",
  "Мексика",
  "Микронезия, Федеративные Штаты",
  "Молдова, Республика",
  "Монако",
  "Монголия",
  "Черногория",
  "Монтсеррат",
  "Марокко",
  "Мозамбик",
  "Мьянма",
  "Намибия",
  "Науру",
  "Непал",
  "Нидерланды",
  "Нидерландские Антильские острова",
  "Новая Каледония",
  "Новая Зеландия",
  "Никарагуа",
  "Нигер",
  "Нигерия",
  "Ниуэ",
  "Остров Норфолк",
  "Северные Марианские острова",
  "Норвегия",
  "Оман",
  "Пакистан",
  "Палау",
  "Палестинская территория, оккупированная",
  "Панама",
  "Папуа - Новая Гвинея",
  "Парагвай",
  "Перу",
  "Филиппины",
  "Питкэрн",
  "Польша",
  "Португалия",
  "Пуэрто-Рико",
  "Катар",
  "Реюньон",
  "Румыния",
  "Российская Федерация",
  "Руанда",
  "Сен-Бартелеми",
  "Святой Елены",
  "Сент-Китс и Невис",
  "Сент-Люсия",
  "Сен-Мартен",
  "Сен-Пьер и Микелон",
  "Святой Винсент и Гренадины",
  "Самоа",
  "Сан-Марино",
  "Сан-Томе и Принсипи",
  "Саудовская Аравия",
  "Сенегал",
  "Сербия",
  "Сербия и Черногория",
  "Сейшельские острова",
  "Сьерра-Леоне",
  "Сингапур",
  "Синт-Мартен",
  "Словакия",
  "Словения",
  "Соломоновы острова",
  "Сомали",
  "Южная Африка",
  "Южная Георгия и Южные Сандвичевы острова",
  "Южный Судан",
  "Испания",
  "Шри-Ланка",
  "Судан",
  "Суринам",
  "Шпицберген и Ян Майен",
  "Свазиленд",
  "Швеция",
  "Швейцария",
  "Сирийская Арабская Республика",
  "Китайский Тайбэй",
  "Таджикистан",
  "Танзания, Объединенная Республика",
  "Таиланд",
  "Тимор-Лешти",
  "Того",
  "Токелау",
  "Тонга",
  "Тринидад и Тобаго",
  "Тунис",
  "Турция",
  "Туркменистан",
  "Острова Теркс и Кайкос",
  "Тувалу",
  "Уганда",
  "Украина",
  "Объединенные Арабские Эмираты",
  "Объединенное Королевство",
  "Соединенные Штаты",
  "Внешние малые острова США",
  "Уругвай",
  "Узбекистан",
  "Вануату",
  "Венесуэла",
  "Вьетнам",
  "Виргинские острова, Британские",
  "Виргинские острова, США",
  "Уоллис и Футуна",
  "Западная Сахара",
  "Йемен",
  "Замбия",
  "Зимбабве"
]

export const countriesArrWithTranslations = {
  ['ru-RU']: countriesArr,
  ['ru-Ru']: countriesArr,
  ru: countriesArr,
  kg: [
    "Кыргызстан", "Ооганстан", "Аланд аралдары", "Албания", "Алжир", "Америкалык Самоа", "Андора", "Ангола", "Ангилья", "Антарктида", "Антигуа жана Барбуда", "Аргентина", "Армения", "Аруба", "Австралия", "Австрия", "Азербайжан", "Багам аралдары", "Бахрейн", "Бангладеш", "Барбадос", "Беларус", "Белгия", "Белиз", "Бенин", "Бермуда", "Бутан", "Боливия", "Бонэйр, Синт Эстатиус жана Саба", "Босния жана Герцеговина", "Ботсвана", "Bouvet Island", "Бразилия", "Британ Индия океаны", "Бруней Даруссалам", "Болгария", "Буркина Фасо", "Бурунди", "Камбожа", "Камерун", "Канада", "Кабо-Верде", "Кайман аралдары", "Борбордук Африка Республикасы", "Чад", "Чили", "Кытай", "Christmas Island", "Кокос (Килинг) аралдары", "Колумбия", "Комор аралдары", "Конго", "Конго, Конго Демократиялык Республикасы", "Кук аралдары", "Коста Рика", "Пил тиши жееги", "Хорватия", "Куба", "Кюрасао", "Кипр", "Чех Республикасы", "Дания", "Жибути", "Доминика", "Доминикан Республикасы", "Эквадор", "Мысыр", "Сальвадор", "Экватордук Гвинея", "Эритрия", "Эстония", "Эфиопия", "Фолкленд аралдары (Мальвин)", "Фарер аралдары", "Фижи", "Финляндия", "Франция", "Француз Гвианасы", "Француз Полинезиясы", "Франциянын Түштүк Аймактары", "Габон", "Гамбия", "Грузия", "Германия", "Гана", "Гибралтар", "Греция", "Гринландия", "Гренада", "Гваделупа", "Гуам", "Гватемала", "Гернси", "Гинея", "Гвинея-Бисау", "Гайана", "Гаити", "Херд аралы жана Макдональд аралдары", "Ыйык Так (Ватикан шаары)", "Гондурас", "Гонконг, Кытай", "Венгрия", "Исландия", "Индия", "Индонезия", "Иран, Ислам Республикасы", "Ирак", "Ирландия", "Мэн аралы", "Израиль", "Италия", "Ямайка", "Жапония", "Джерси", "Иордания", "Казакстан", "Кения", "Кирибати", "Корея, Демократиялык Элдик Республикасы", "Корея, Республикасы", "Косово", "Кувейт", "Лаос Элдик Демократиялык Республикасы", "Латвия", "Ливан", "Лесото", "Либерия", "Ливия Араб Джамахириясы", "Лихтенштейн", "Литва", "Люксембург", "Макао, Кытай", "Македония, Мурунку Югославия Республикасы", "Мадагаскар", "Малави", "Малайзия", "Малдивдер", "Мали", "Малта", "Маршал аралдары", "Мартиника", "Мавритания", "Маврикий", "Майотта", "Мексика", "Микронезия, Федеративдик Штаттар", "Молдова, Республикасы", "Монако", "Монголия", "Монтенегро", "Монтсеррат", "Марокко", "Мозамбик", "Мьянма", "Намбия", "Науру", "Непал", "Голландия", "Нидерланддар Антил аралдары", "Жаңы Каледония", "Жаңы Зеландия", "Никарагуа", "Нигер", "Нигерия", "Ниуэ", "Норфолк аралы", "Түндүк Мариан Аралдары", "Норвегия", "Оман", "Пакистан", "Палау", "Палестина аймагы, Басылып алынган", "Панама", "Папуа Жаңы Гвинея", "Парагвай", "Перу", "Филиппиндер", "Питкэрн", "Польша", "Португалия", "Пуэрто Рико", "Катар", "Reunion", "Румыния", "Орус Федерациясы", "Руанда", "Ыйык Бартелеми", "Ыйык Елена аралы", "Сент-Китс жана Невис", "Сент-Люсия", "Синт-Мартин", "Сент-Пьер жана Микелон", "Сент-Винсент жана Гренадиндер", "Самоа", "Сан Марино", "Сан-Томе жана Принсипи", "Сауд Арабиясы", "Сенегал", "Сербия", "Сербия жана Черногория", "Сейшел аралдары", "Сьерра-Леоне", "Сингапур", "Сент-Мартин", "Словакия", "Словения", "Соломон аралдары", "Сомалия", "Түштүк Африка", "Түштүк Грузия жана Түштүк Сэндвич аралдары", "түштүк Судан", "Испания", "Шри Ланка", "Судан", "Суринам", "Шпицберген жана Ян Майен", "Свазиленд", "Швеция", "Швейцария", "Сирия Араб Республикасы", "Тайбэй, Кытай", "Тажикистан", "Танзания, Бириккен Республикасы", "Тайланд", "Тимор-Лесте", "Баруу", "Токелау", "Тонга", "Тринидад жана Тобаго", "Тунис", "Туркия", "Түркмөнстан", "Теркс жана Кайкос аралдары", "Тувалу", "Уганда", "Украина", "Кошмо Араб Эмираттар", "Улуу Британия", "Кошмо штаттар", "Америка Кошмо Штаттарынын Кичи жана алыскы аралдары", "Уругвай", "Өзбекстан", "Вануату", "Венесуэла", "Вьетнам", "Виргин аралдары, Британия", "Виргин аралдары, АКШ", "Уоллис жана Футуна", "Батыш Сахара", "Йемен", "Замбия", "Зимбабве"
  ],
  ['ky']: [
    "Кыргызстан", "Ооганстан", "Аланд аралдары", "Албания", "Алжир", "Америкалык Самоа", "Андора", "Ангола", "Ангилья", "Антарктида", "Антигуа жана Барбуда", "Аргентина", "Армения", "Аруба", "Австралия", "Австрия", "Азербайжан", "Багам аралдары", "Бахрейн", "Бангладеш", "Барбадос", "Беларус", "Белгия", "Белиз", "Бенин", "Бермуда", "Бутан", "Боливия", "Бонэйр, Синт Эстатиус жана Саба", "Босния жана Герцеговина", "Ботсвана", "Bouvet Island", "Бразилия", "Британ Индия океаны", "Бруней Даруссалам", "Болгария", "Буркина Фасо", "Бурунди", "Камбожа", "Камерун", "Канада", "Кабо-Верде", "Кайман аралдары", "Борбордук Африка Республикасы", "Чад", "Чили", "Кытай", "Christmas Island", "Кокос (Килинг) аралдары", "Колумбия", "Комор аралдары", "Конго", "Конго, Конго Демократиялык Республикасы", "Кук аралдары", "Коста Рика", "Пил тиши жееги", "Хорватия", "Куба", "Кюрасао", "Кипр", "Чех Республикасы", "Дания", "Жибути", "Доминика", "Доминикан Республикасы", "Эквадор", "Мысыр", "Сальвадор", "Экватордук Гвинея", "Эритрия", "Эстония", "Эфиопия", "Фолкленд аралдары (Мальвин)", "Фарер аралдары", "Фижи", "Финляндия", "Франция", "Француз Гвианасы", "Француз Полинезиясы", "Франциянын Түштүк Аймактары", "Габон", "Гамбия", "Грузия", "Германия", "Гана", "Гибралтар", "Греция", "Гринландия", "Гренада", "Гваделупа", "Гуам", "Гватемала", "Гернси", "Гинея", "Гвинея-Бисау", "Гайана", "Гаити", "Херд аралы жана Макдональд аралдары", "Ыйык Так (Ватикан шаары)", "Гондурас", "Гонконг, Кытай", "Венгрия", "Исландия", "Индия", "Индонезия", "Иран, Ислам Республикасы", "Ирак", "Ирландия", "Мэн аралы", "Израиль", "Италия", "Ямайка", "Жапония", "Джерси", "Иордания", "Казакстан", "Кения", "Кирибати", "Корея, Демократиялык Элдик Республикасы", "Корея, Республикасы", "Косово", "Кувейт", "Лаос Элдик Демократиялык Республикасы", "Латвия", "Ливан", "Лесото", "Либерия", "Ливия Араб Джамахириясы", "Лихтенштейн", "Литва", "Люксембург", "Макао, Кытай", "Македония, Мурунку Югославия Республикасы", "Мадагаскар", "Малави", "Малайзия", "Малдивдер", "Мали", "Малта", "Маршал аралдары", "Мартиника", "Мавритания", "Маврикий", "Майотта", "Мексика", "Микронезия, Федеративдик Штаттар", "Молдова, Республикасы", "Монако", "Монголия", "Монтенегро", "Монтсеррат", "Марокко", "Мозамбик", "Мьянма", "Намбия", "Науру", "Непал", "Голландия", "Нидерланддар Антил аралдары", "Жаңы Каледония", "Жаңы Зеландия", "Никарагуа", "Нигер", "Нигерия", "Ниуэ", "Норфолк аралы", "Түндүк Мариан Аралдары", "Норвегия", "Оман", "Пакистан", "Палау", "Палестина аймагы, Басылып алынган", "Панама", "Папуа Жаңы Гвинея", "Парагвай", "Перу", "Филиппиндер", "Питкэрн", "Польша", "Португалия", "Пуэрто Рико", "Катар", "Reunion", "Румыния", "Орус Федерациясы", "Руанда", "Ыйык Бартелеми", "Ыйык Елена аралы", "Сент-Китс жана Невис", "Сент-Люсия", "Синт-Мартин", "Сент-Пьер жана Микелон", "Сент-Винсент жана Гренадиндер", "Самоа", "Сан Марино", "Сан-Томе жана Принсипи", "Сауд Арабиясы", "Сенегал", "Сербия", "Сербия жана Черногория", "Сейшел аралдары", "Сьерра-Леоне", "Сингапур", "Сент-Мартин", "Словакия", "Словения", "Соломон аралдары", "Сомалия", "Түштүк Африка", "Түштүк Грузия жана Түштүк Сэндвич аралдары", "түштүк Судан", "Испания", "Шри Ланка", "Судан", "Суринам", "Шпицберген жана Ян Майен", "Свазиленд", "Швеция", "Швейцария", "Сирия Араб Республикасы", "Тайбэй, Кытай", "Тажикистан", "Танзания, Бириккен Республикасы", "Тайланд", "Тимор-Лесте", "Баруу", "Токелау", "Тонга", "Тринидад жана Тобаго", "Тунис", "Туркия", "Түркмөнстан", "Теркс жана Кайкос аралдары", "Тувалу", "Уганда", "Украина", "Кошмо Араб Эмираттар", "Улуу Британия", "Кошмо штаттар", "Америка Кошмо Штаттарынын Кичи жана алыскы аралдары", "Уругвай", "Өзбекстан", "Вануату", "Венесуэла", "Вьетнам", "Виргин аралдары, Британия", "Виргин аралдары, АКШ", "Уоллис жана Футуна", "Батыш Сахара", "Йемен", "Замбия", "Зимбабве"
  ],
  ['en-US']: [
    "Kyrgyzstan", "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Caribbean Netherlands", "Bosnia & Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo - Brazzaville", "Congo - Kinshasa", "Cook Islands", "Costa Rica", "Côte d’Ivoire", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Islas Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard & McDonald Islands", "Vatican City", "Honduras", "Hong Kong, China ", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "North Korea", "South Korea", "Kosovo", "Kuwait", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao, China", "North Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar (Burma)", "Namibia", "Nauru", "Nepal", "Netherlands", "Curaçao", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn Islands", "Poland", "Portugal", "Puerto Rico", "Qatar", "Réunion", "Romania", "Russia", "Rwanda", "St. Barthélemy", "St. Helena", "St. Kitts & Nevis", "St. Lucia", "St. Martin", "St. Pierre & Miquelon", "St. Vincent & Grenadines", "Samoa", "San Marino", "São Tomé & Príncipe", "Saudi Arabia", "Senegal", "Serbia", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia & South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard & Jan Mayen", "Eswatini", "Sweden", "Switzerland", "Syria", "Chinese Taipei", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "U.S. Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "British Virgin Islands", "U.S. Virgin Islands", "Wallis & Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"
  ],
  en: [
    "Kyrgyzstan", "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Caribbean Netherlands", "Bosnia & Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo - Brazzaville", "Congo - Kinshasa", "Cook Islands", "Costa Rica", "Côte d’Ivoire", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Islas Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard & McDonald Islands", "Vatican City", "Honduras", "Hong Kong, China ", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "North Korea", "South Korea", "Kosovo", "Kuwait", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao, China", "North Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar (Burma)", "Namibia", "Nauru", "Nepal", "Netherlands", "Curaçao", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn Islands", "Poland", "Portugal", "Puerto Rico", "Qatar", "Réunion", "Romania", "Russia", "Rwanda", "St. Barthélemy", "St. Helena", "St. Kitts & Nevis", "St. Lucia", "St. Martin", "St. Pierre & Miquelon", "St. Vincent & Grenadines", "Samoa", "San Marino", "São Tomé & Príncipe", "Saudi Arabia", "Senegal", "Serbia", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia & South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard & Jan Mayen", "Eswatini", "Sweden", "Switzerland", "Syria", "Chinese Taipei", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "U.S. Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "British Virgin Islands", "U.S. Virgin Islands", "Wallis & Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"
  ]
};

export const gendersArr = ["profilePage.female", "profilePage.male"];

export const sizesArr = ["XS", "S", "M", "L", "XL", "XXL"];
